import EventEmitter from "../../../node_modules/eventemitter3/index";
import {

  StagesClient,
  WebhookConfigurationCreateDto,
  WebhookConfigurationsClient,
} from "../client/Client";
import events from "../Events/EventList";
import { addOptionsToSelect, createOptions } from "../Utilities/Select";



export default class WebhookComponent {
  $description = <HTMLInputElement>document.querySelector("#description");
  $stageId = <HTMLSelectElement>document.querySelector("#stageId");
  $plantillaId = <HTMLSelectElement>document.querySelector("#plantillaId");
  $maxRetry = <HTMLInputElement>document.querySelector("#maxRetry");
  $url = <HTMLInputElement>document.querySelector("#url");
  $transitionId = <HTMLInputElement>document.querySelector("#transitionId");
  $version = <HTMLInputElement>document.querySelector("#version");
  $webhookForm = <HTMLFormElement>document.querySelector("#webhook-main-form");

  /**
   *
   */
  constructor(
    private webhookClient: WebhookConfigurationsClient,
    private eventEmmiter: EventEmitter,
    private stageCliente: StagesClient
  ) {
    this.$webhookForm.onsubmit = this.formSubmitHandler;
    this.$plantillaId.onchange=this.updateStages;
  }

  updateStages = async ()=>{
    this.$stageId.textContent = '';
    let stages = await this.stageCliente.getParaPlantilla(parseInt(this.$plantillaId.value));
    let options = createOptions(stages,(s)=>s.id.toString(), (s)=>s.name);
    addOptionsToSelect(this.$stageId,options);
  }

  formSubmitHandler = async (evt: Event) => {
    evt.preventDefault();

    let dto = new WebhookConfigurationCreateDto();

    dto.description = this.$description.value;
    dto.maxRetry =  isNaN(parseInt(this.$maxRetry.value))?0:parseInt(this.$maxRetry.value);;
    dto.stageId = isNaN(parseInt(this.$stageId.value))?0:parseInt(this.$stageId.value);
    dto.plantillaId = parseInt(this.$plantillaId.value);
    dto.url = this.$url.value;
    dto.transitionId = isNaN(parseInt(this.$transitionId.value)) ? 0 : parseInt(this.$transitionId.value);
    dto.version = isNaN(parseInt(this.$version.value)) ? 0 : parseInt(this.$version.value);
    await this.addWebhook(dto);

    return false;
  };
  addWebhook = async (stage: WebhookConfigurationCreateDto) => {
    try {
      await this.webhookClient.post(stage);
      Notify.success("Webhook creado");
      this.eventEmmiter.emit(events.WEBHOOK_CREATED);
      this.$webhookForm.reset();
    } catch (ex) {
      Notify.handleApiError(ex);
    }
  };
}
